import ProductGroup, {ProductGroupLevel} from "@/types/product-group";
import {Box, Divider, Typography} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import React, {memo} from "react";
import {useAppSelector} from "@/redux/hooks";
import {useTheme} from "@mui/material/styles";
import {productGroupNames} from "@/types/product-group";
import {useProductsFilters} from "@/hooks/useProductsFilters";

function ProductsFilterAccordionItem({item, type, checkboxId}: { item: ProductGroup; type: ProductGroupLevel; checkboxId: string; }) {
    const theme = useTheme()
    const {updateFilters} = useProductsFilters()
    const selectedIds = useAppSelector(
        state => state.products[productGroupNames[type] as keyof typeof state.products] as number[] ?? []
    )

    function isEnglish(word: string) {
        const p: RegExp = /^[a-zA-Z\s]+$/;
        return p.test(word);
    }

    const words = item.name.split(" ");
    const englishName = words.filter(isEnglish).join(" ").toUpperCase();
    const persianName = words.filter((word) => !isEnglish(word)).join(" ");

    return (
        <>
            <Box
                display = "flex"
                alignItems = "center"
                sx = {{cursor: 'pointer',py:1}}
                component = "label"
                htmlFor = {checkboxId}
                key = {item.name}
            >
                <Checkbox
                    id = {checkboxId}
                    edge = "end"
                    checked = {item?.isChecked}
                    name = {item.id.toString()}
                    data-section_id = {item.name}
                    onChange = {() => {
                        const id = +item.id;
                        const nextIds = selectedIds.includes(id)
                            ? selectedIds.filter(itemId => itemId !== id)
                            : [...selectedIds, id];
                        updateFilters({[productGroupNames[type]]: nextIds});
                    }}
                    sx = {{
                        mr: 2,
                        p: 0,
                    }}
                />

                <ListItemText sx = {{flex: "unset", minWidth: "auto"}} primary = {persianName} />

                <Typography color = {theme.palette.text.secondary} pl = {1} fontSize = {14} pb = {-1} >
                    {englishName}
                </Typography >

            </Box >
            <Divider sx = {{ml: 5}} />

            <style jsx global >{`
                 @keyframes fadeInCheck {
                      from {
                           opacity : 0;
                           }
                      to {
                           opacity : 1;
                           }
                      }
            `}</style >
        </>
    );
}

export default memo(
    ProductsFilterAccordionItem,
    (prevProps, nextProps) =>
        prevProps.item.isChecked === nextProps.item.isChecked &&
        prevProps.item.id === nextProps.item.id &&
        prevProps.checkboxId === nextProps.checkboxId
);
